import React from 'react';
import MassFinalizeItem from '../../../Domain/MassFinalizeItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';

export default class BulkFinalizeClientInvoiceDescription extends React.Component {
  static titleForEdit = 'Invoice Bulk Finalization';
  static finishButtonLabel = 'Finalize';
  static itemType = MassFinalizeItem;
  static serviceFunction = ClientInvoiceService.BulkFinalizeInvoice;

  // CD-5483: the number of the newest note request; a request that is no longer the newest leaves the note alone.
  static noteRequestCount = 0;

  // CD-5483: the note of the invoices typed so far, fetched once typing pauses. Every keystroke calls this, and only
  // the newest call sets the note, so a slow answer for earlier ids never replaces a newer one. Returns nothing: the
  // pop-up then takes over the note alone, never the ids typed since.
  static async loadApprovalNote(editedItem) {
    const request = ++BulkFinalizeClientInvoiceDescription.noteRequestCount;
    await new Promise((resolve) => {
      setTimeout(resolve, 600);
    });
    if (request !== BulkFinalizeClientInvoiceDescription.noteRequestCount) {
      return;
    }

    let note = '';
    if (/\d/.test(editedItem.IdListString ?? '')) {
      const noteRequest = new MassFinalizeItem();
      noteRequest.IdListString = editedItem.IdListString;
      note = await ClientInvoiceService.GetFinalizeApprovalNote(noteRequest);
    }

    if (request === BulkFinalizeClientInvoiceDescription.noteRequestCount) {
      editedItem.EvaluatorPaymentApprovalNote = note;
    }
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IdListString',
          label: 'Invoice IDs (id1,id2,id3...)',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          onFieldChange: BulkFinalizeClientInvoiceDescription.loadApprovalNote,
        },
        {
          // CD-5483: empty, and hidden, when no evaluator payment of the invoices would need supervisor approval.
          fieldName: 'EvaluatorPaymentApprovalNote',
          label: 'Supervisor approval',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.EvaluatorPaymentApprovalNote,
        },
      ],
    },
  ];
}
